module.exports = __webpack_public_path__ + "static/media/toilet1.ac9f3485.png";